import { render } from "./PassingRouteComponent.vue?vue&type=template&id=42ab42d1&scoped=true"
import script from "./PassingRouteComponent.vue?vue&type=script&lang=js"
export * from "./PassingRouteComponent.vue?vue&type=script&lang=js"

import "./PassingRouteComponent.vue?vue&type=style&index=0&id=42ab42d1&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ab42d1"]])

export default __exports__